<template>
  <div v-loading="loading">
    <el-input
      v-model="config.title"
      clearable=""
      style="margin-bottom:10px;"
      placeholder="请输入内容标题">
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="fetchList"></el-button>
    </el-input>
    <el-table
      :data="items"
      height="600px"
      border=""
      @row-click="selectitem">
      <el-table-column
        prop="title"
        label="内容标题"
        min-width="240">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'MessageInfo',
  props: {
    linkType: { type: Number, default: -1 },
    contentTypes: { type: Array, default: () => [0] }
  },
  data() {
    return {
      loading: false,
      items: [],
      config: { title: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    selectitem(item) {
      this.$emit('select', { linkType: this.linkType, link: item.msgId, title: item.title, contentType: item.contentType })
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('portal/getmessages', {
        payload: { ...this.config, pageNum: 1, pageSize: 10000, contentTypes: this.contentTypes },
        success: res => {
          this.loading = false
          this.items = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style>

</style>
